/**
 * Pre-register all Iconify icons used in the app so they're bundled at build time
 * instead of fetched from the CDN at runtime.
 *
 * Import this file once in the app entry point (e.g. index.js).
 *
 * To add a new icon: run the extraction script or manually add the icon data
 * to iconifyBundledIcons.json with the key "prefix:name".
 *
 * Note: @iconify/react v6 removed the localStorage icon cache entirely (and with it
 * the `disableCache`/`enableCache` exports) for GDPR compliance. Because every icon
 * used here is registered via `addIcon` below, the components never hit the Iconify
 * API or any browser cache, so there is nothing left to disable — the previous
 * `disableCache('all')` call is obsolete in v6 and has been removed.
 */
import { addIcon } from '@iconify/react';
import bundledIcons from './iconifyBundledIcons.json';

// Register all bundled icons
Object.entries(bundledIcons).forEach(([name, data]) => {
  addIcon(name, data);
});
